/**
 * UpdateBanner — formerly used by the Electron auto-updater. Now that the app
 * is browser-only, there's nothing to update behind the user's back; the
 * browser fetches the latest assets from Coolify on every page load. Kept as
 * an empty component so existing JSX references (e.g. in UploadWizard) keep
 * working without a refactor.
 */
export default function UpdateBanner() {
  return null;
}
